
export const BusinessdocumentActionTypes = {
    API_RESPONSE_SUCCESS: '@@businessdocument/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@businessdocument/API_RESPONSE_ERROR',

    LIST_BUSINESSDOCUMENT: '@@businessdocument/LIST_BUSINESSDOCUMENT',
    SHOW_BUSINESSDOCUMENT: '@@businessdocument/SHOW_BUSINESSDOCUMENT',
    FILTER_BUSINESSDOCUMENT: '@@businessdocument/FILTER_BUSINESSDOCUMENT',
};